import { render, staticRenderFns } from "./VerificarEstadoInscripcionDialog.vue?vue&type=template&id=08ef1404&"
import script from "./VerificarEstadoInscripcionDialog.vue?vue&type=script&lang=js&"
export * from "./VerificarEstadoInscripcionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports